import React from "react";
import styled from "styled-components";
import { Tabs } from "../";
import { Main } from "../../styles/";

const StyledSkills = styled(Main)`
  display: flex;
  justify-content: center;
`;

const skillsInitial = [
  {
    id: 0,
    header: "Frontend",
    items: [
      { text: "HTML", color: "#FF6E30" },
      { text: "CSS", color: "#416BFF" },
      { text: "SASS", color: "#F38F8F" },
      { text: "Javascript", color: "#FFF500" },
      { text: "React", color: "#66DCF5" },
      { text: "Webpack", color: "#00A5FF" },
      { text: "Babel", color: "#FFFA79" },
      { text: "Rest", color: "#47D83A" },
    ],
  },
  {
    id: 1,
    header: "Backend",
    items: [{ text: "Flask (Python)", color: "#177e0e" }],
  },
  {
    id: 2,
    header: "Design",
    items: [{ text: "Figma", color: "#f12626" }],
  },
  {
    id: 3,
    header: "Other",
    items: [{ text: "Git", color: "#FF6E30" }],
  },
];

export const Skills = () => {
  const [skills, setSkills] = React.useState(skillsInitial); // eslint-disable-line
  return (
    <StyledSkills>
      <Tabs tabData={skills} />
    </StyledSkills>
  );
};
